// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../data/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../data/node_modules/css-loader/dist/cjs.js??ref--9-oneOf-1-1!../../../data/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../data/node_modules/postcss-loader/src/index.js??ref--9-oneOf-1-2!vue-multiselect/dist/vue-multiselect.min.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, "/* Bulma Utilities */\n.multiselect.error .multiselect__tags {\n  border: 1px solid red;\n}\n", ""]);
// Exports
module.exports = exports;
